// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__iP9Xs","pulse":"styles_pulse__OJwbI","jump":"styles_jump__gjcMz"};